import { render, staticRenderFns } from "./IconArrowRight.vue?vue&type=template&id=2eee1288"
import script from "./IconArrowRight.vue?vue&type=script&lang=js"
export * from "./IconArrowRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports